import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { StickyContainer, Sticky } from "react-sticky";
import { Link } from "react-router-dom";
import { moment } from "../common/common";

import { getLoggedProfile } from "../../model/profile";
import {
	getBalance,
	getInvoiceByMonth,
	withdrawMoney,
	getRequestWithdraw,
	updateBankInfo,
	updateViettelpayInfo,
	getBankList,
} from "../../model/wallet";

import { commonErr } from "../common/errors";
import { MessageBox } from "../common/messagebox";
import { LoadingPage, LoadingInline } from "../common/loading";

import Login from "../login/login";
import SignUp from "../login/signup";

import Header from "../components/header";

import { IcBackReport, IcSearchBank } from "../common/svg";
import vtpay from "../../static/images/viettelpay.svg";
import bank from "../../static/images/payments/cards.svg";

import { IcStarRating, IcSearchDropDown } from "../common/svg";
import { MY_CARS } from "../../constant/routes";

const withdrawMethods = {
	BANK: 1,
	VIETTELPAY: 2,
};

class WalletItem extends React.Component {
	constructor(props) {
		super(props);
	}

	getTotalTrasactionAmount = (listTransaction) => {
		var total = 0;
		var i;
		if (listTransaction && listTransaction.length > 0) {
			for (i = 0; i < listTransaction.length; ++i) {
				var transaction = listTransaction[i];
				total += transaction.amount;
			}
		}
		return total;
	};

	render() {
		const data = this.props.data;
		var rating = parseFloat(data.rating.avg).toFixed(1);
		// var n = parseFloat(x); x = Math.round(n * 1000) / 1000; alert(x)
		return (
			<div>
				<div className="info-display">
					<div className="info-display--item">
						<div className="group-ratings">
							<IcStarRating />
							<span className="highlight">{rating}</span>
						</div>
						<p className="desc">Đánh giá</p>
					</div>
					<div className="info-display--item">
						<span className="highlight">{data.totalTripFinished} </span>
						<p className="desc">Chuyến đi thành công</p>
					</div>
					<div className="info-display--item d-flex">
						<div className="response-desc">
							<span className="highlight">{data.responseRate} </span>
							<p className="desc">Tỉ lệ phản hồi </p>
						</div>
						<div className="response-desc">
							<span className="highlight">{data.responseTime}</span>
							<p className="desc">Thời gian phản hồi </p>
						</div>
						<div className="response-desc">
							<span className="highlight">{data.acceptRate} </span>
							<p className="desc">Tỉ lệ đồng ý</p>
						</div>
					</div>
				</div>
				<div className="transaction-detail__wrap">
					<div className="transaction-detail__table">
						<div className="row-transaction main-row">
							<div className="desc">
								<p>Mã chuyến đi</p>
							</div>
							<div className="desc">
								<p>Hình thức</p>
							</div>
							<div className="desc">
								<p>Ngày đi</p>
							</div>
							<div className="desc">
								<p>Ngày về</p>
							</div>
							<div className="desc">
								<p>Đơn giá thuê</p>
							</div>
							<div className="desc">
								<p>Doanh thu chủ xe</p>
							</div>
							<div className="desc">
								<p>Tiền đã nhận</p>
							</div>
							{/* <div className="desc">
							<p>Phí Vận hành</p>
						</div> */}
							<div className="desc">
								<p>Thay đổi số dư</p>
							</div>
						</div>
						{data.transactionsFinished &&
							data.transactionsFinished.length > 0 &&
							data.transactionsFinished.map((transaction) => (
								<div className="row-transaction" key={transaction.trip.id}>
									<div className="desc">
										<p>
											<a href={`/trip/detail/${transaction.trip.id}`} target="_blank">
												{transaction.trip.id}
											</a>
										</p>
									</div>
									<div className="desc">{transaction.trip.serviceType === 1 ? <p>Tự lái</p> : <p>Có tài xế</p>}</div>
									<div className="desc">
										<p>{moment(transaction.trip.tripDateFrom).format("DD/MM/YYYY")}</p>
									</div>
									<div className="desc">
										<p>{moment(transaction.trip.tripDateTo).format("DD/MM/YYYY")}</p>
									</div>
									<div className="desc">
										<p>
											<NumberFormat
												value={transaction.trip.price}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ"}
											/>
										</p>
									</div>
									<div className="desc">
										<p>
											<NumberFormat
												value={transaction.trip.price - transaction.trip.fee}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ"}
											/>
										</p>
									</div>
									<div className="desc">
										<p>
											<NumberFormat
												value={transaction.trip.payAfter}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ"}
											/>
										</p>
									</div>
									{/* <div className="desc"> 
							<p><NumberFormat value={transaction.trip.fee} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
						</div> */}
									<div className="desc">
										<p>
											<NumberFormat
												value={transaction.amount}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ"}
											/>
										</p>
									</div>
								</div>
							))}
					</div>
					<div className="summary-change">
						<p>Tổng thay đổi - Chuyến đi hoàn thành</p>
						<p>
							<NumberFormat
								value={this.getTotalTrasactionAmount(data.transactionsFinished)}
								displayType={"text"}
								thousandSeparator={" "}
								decimalSeparator={","}
								suffix={"đ"}
							/>
						</p>
					</div>
					<div className="summary-change">
						<p>Tổng thay đổi - Giao dịch rút/nộp tiền</p>
						<p>
							<NumberFormat
								value={this.getTotalTrasactionAmount(data.transactionsOther)}
								displayType={"text"}
								thousandSeparator={" "}
								decimalSeparator={","}
								suffix={"đ"}
							/>
						</p>
					</div>
					<div className="summary-change">
						<p>Tổng thay đổi - Giao dịch hủy chuyến</p>
						<p>
							<NumberFormat
								value={this.getTotalTrasactionAmount(data.transactionsCanceled)}
								displayType={"text"}
								thousandSeparator={" "}
								decimalSeparator={","}
								suffix={"đ"}
							/>
						</p>
					</div>
					<div className="group-summary">
						<div className="transaction-summary">
							<p>TỔNG CỘNG THAY ĐỔI TRONG KÌ</p>
							<p>
								<NumberFormat
									value={data.endingBalance - data.openingBalance}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ"}
								/>
							</p>
						</div>
						<div className="transaction-summary">
							<p>TIỀN ĐẦU KÌ</p>
							<p>
								<NumberFormat
									value={data.openingBalance}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ"}
								/>
							</p>
						</div>
						<div className="transaction-summary">
							<p>TIỀN CUỐI KÌ</p>
							<p className="sum-price">
								<NumberFormat
									value={data.endingBalance}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ"}
								/>
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class MyWallet extends Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			monthInMilliseconds: 0,
			showWithdrawMethod: false,
			showRegisterVtpay: false,
			showWithdrawByVtpay: false,
			showWithdrawRequest: false,
			amount: 0,
			accountNumber: "",
			accountName: "",
			bankName: "",
			alertMsg: "",
			withdrawMethod: 1,
			showListBank: false,
			searchField: "",
			banks: [],
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.refreshCheckFilled();
		this.getWalletInfo(0);
		getLoggedProfile().then((resp) => {
			if (resp.data.data && resp.data.data.profile) {
				const profile = resp.data.data.profile;
				this.setState({
					profile: profile,
					phoneNumberRegis: profile.phoneNumber,
				});
			} else {
				this.setState({
					showLoginForm: true,
				});
			}
		});
		getBankList().then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.banks) {
				this.setState({
					banks: resp.data.data.banks,
				});
			} else {
				this.setState({
					err: resp.data.error,
				});
			}
		});
	}

	initMonthData = () => {
		var monthData = [];
		for (let m = 0; m < 12; m++) {
			monthData.push({
				monthInMilliseconds: moment().subtract(m, "months").startOf("month").valueOf(),
				monthInText: moment().subtract(m, "months").startOf("month").format("DD-MM-YYYY"),
			});
		}
		return monthData;
	};

	getWalletInfo(monthInMilliseconds) {
		var month = monthInMilliseconds > 0 ? monthInMilliseconds : moment().startOf("month").valueOf();
		const self = this;
		getBalance().then(function (resp) {
			if (resp.data.error === commonErr.SUCCESS) {
				self.setState({
					balance: resp.data.data.balance,
					amount: resp.data.data.balance,
				});
			} else {
				self.setState({
					err: resp.data.error,
				});
			}
		});
		getInvoiceByMonth(month).then(function (resp) {
			if (resp.data.error === commonErr.SUCCESS) {
				self.setState({
					monthInMilliseconds: month,
					data: resp.data.data,
					// timeRequested: resp.data.data.timeRequested,
					// accountNumber: resp.data.data.accountNumber && resp.data.data.accountNumber,
					// accountName: resp.data.data.accountName && resp.data.data.accountName,
					// bankName: resp.data.data.bankName && resp.data.data.bankName,
					// bankProvince: resp.data.data.bankProvince && resp.data.data.bankProvince,
					// bankBranch: resp.data.data.bankBranch && resp.data.data.bankBranch,
				});
			} else {
				self.setState({
					err: resp.data.error,
					data: null,
				});
			}
		});
		getRequestWithdraw().then((resp) => {
			if (resp.data.error === commonErr.SUCCESS) {
				this.setState({
					timeRequested: resp.data.data.timeRequested,
					accountNumber: resp.data.data.bank ? resp.data.data.bank.accountNumber : "",
					accountName: resp.data.data.bank ? resp.data.data.bank.accountName : "",
					bankName: resp.data.data.bank ? resp.data.data.bank.bankName : "",
					vtpay: resp.data.data.viettelPay,
					vtpayTimeRequested: resp.data.data.viettelPay ? resp.data.data.viettelPay.timeRequested : 0,
					vtpayTimeActived: resp.data.data.viettelPay ? resp.data.data.viettelPay.timeActived : 0,
					vtPayPhoneNumber: resp.data.data.viettelPay ? resp.data.data.viettelPay.phoneNumber : 0,
					vtPayFullName: resp.data.data.viettelPay ? resp.data.data.viettelPay.fullName : "",
				});
			} else {
				this.setState({
					err: resp.data.error,
				});
			}
		});
	}

	//-- Login

	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	showLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	openSignupForm = () => {
		this.setState({
			showSignup: true,
		});
	};

	closeSignupForm = () => {
		this.setState({
			showSignup: false,
		});
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	onSelectMonthChange = (event) => {
		var monthInMilliseconds = event.target.value;
		this.setState({
			monthInMilliseconds: monthInMilliseconds,
		});
		this.getWalletInfo(monthInMilliseconds);
	};

	openWithdrawRequest = () => {
		this.setState({
			showWithdrawRequest: true,
		});
	};

	openWithdrawMethod = () => {
		this.setState({
			showWithdrawMethod: true,
		});
		this.getBankName(); //get name and subName of bank account
	};

	openRegisterVtpay = () => {
		this.setState({
			showRegisterVtpay: true,
		});
	};

	confirmCancelWithdrawRequest = () => {
		this.setState({
			showConfirmCancelWithdraw: true,
		});
	};

	cancelWithdrawRequest = () => {
		this.setState({ err: commonErr.LOADING });
		withdrawMoney(true, undefined).then((resp) => {
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				showConfirmCancelWithdraw: false,
			});
		});
		this.getWalletInfo(0);
	};

	cancelRegisterVtpay = () => {
		this.setState({ err: commonErr.LOADING });
		const phoneNumber = this.state.profile.phoneNumber;
		updateViettelpayInfo(true, phoneNumber).then((resp) => {
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				showRegisterVtpay: false,
			});
		});
		this.getWalletInfo(0);
	};

	closeWithdrawRequest = () => {
		this.setState({
			showWithdrawRequest: false,
		});
	};

	closeWithdrawMethod = () => {
		this.setState({
			showWithdrawMethod: false,
		});
	};

	closeRegisterVtpay = () => {
		this.setState({
			showRegisterVtpay: false,
		});
	};

	handleInputChange = (event) => {
		this.setState(
			{
				[event.target.name]: event.target.value,
			},
			() => this.isValidInfo(this.state.withdrawMethod)
		);
	};

	amountChangedHandler = (values) => {
		this.setState({ amount: values.value }, () => this.isValidInfo(this.state.withdrawMethod));
	};

	refreshCheckFilled = () => {
		this.setState({
			isAccountNameValid: true,
			isAccountNumberValid: true,
			isAmountValid: true,
			isBankNameValid: true,
			isVtPayPhoneNumberValid: true,
			isVtPayFullNameValid: true,
			isPhoneNUmberRegisValid: true,
			alertMsg: "",
		});
	};

	isValidInfo = (method) => {
		this.refreshCheckFilled();
		if (this.state.amount <= 0 || !this.state.amount) {
			this.setState({
				isAmountValid: false,
				alertMsg: "Bạn chưa điền số tiền cần rút",
			});
			return "Bạn chưa điền số tiền cần rút";
		}

		if (this.state.amount > this.state.balance) {
			this.setState({
				isAmountValid: false,
				alertMsg: "Số tiền cần rút vượt quá số dư hiện có",
			});
			return "Số tiền cần rút vượt quá số dư hiện có";
		}

		if (method === withdrawMethods.VIETTELPAY) {
			if (this.state.vtPayPhoneNumber === 0 || !this.state.vtPayPhoneNumber) {
				this.setState({
					isVtPayPhoneNumberValid: false,
					alertMsg: "Số điện thoại không hợp lệ, vui lòng liên hệ tổng đài MIOTO để được hỗ trợ.",
				});
				return "Số điện thoại không hợp lệ, vui lòng liên hệ tổng đài MIOTO để được hỗ trợ.";
			}
			if (this.state.vtPayFullName === "" || !this.state.vtPayFullName) {
				this.setState({
					isVtPayFullNameValid: false,
					alertMsg: "Họ tên đăng ký không hợp lệ, vui lòng liên hệ tổng đài MIOTO để được hỗ trợ.",
				});
				return "Họ tên đăng ký không hợp lệ, vui lòng liên hệ tổng đài MIOTO để được hỗ trợ.";
			}

			return "";
		}

		// check valid bank account
		if (this.state.accountNumber === "" || !this.state.accountNumber) {
			this.setState({
				isAccountNumberValid: false,
				alertMsg: "Bạn chưa điền số tài khoản",
			});
			return "Bạn chưa điền số tài khoản";
		}

		if (this.state.accountName === "" || !this.state.accountName) {
			this.setState({
				isAccountNameValid: false,
				alertMsg: "Bạn chưa điền tên người thụ hưởng",
			});
			return "Bạn chưa điền tên người thụ hưởng";
		}

		if (this.state.bankName === "" || !this.state.bankName) {
			this.setState({
				isBankNameValid: false,
				alertMsg: "Bạn chưa điền tên ngân hàng thụ hưởng",
			});
			return "Bạn chưa điền tên ngân hàng thụ hưởng";
		}

		return "";
	};

	openVtPayRequest = () => {
		if (this.state.vtpay !== null && this.state.vtpayTimeActived > 0 && this.state.vtPayPhoneNumber !== 0) {
			this.setState({
				showWithdrawRequest: true,
			});
		} else {
			this.setState({
				showRegisterVtpay: true,
			});
		}
	};

	onContinueWWithdrawMethod = () => {
		const withdrawMethod = this.state.withdrawMethod;

		switch (withdrawMethod) {
			case withdrawMethods.VIETTELPAY:
				this.closeWithdrawMethod();
				this.openVtPayRequest();
				break;
			case withdrawMethods.BANK:
				this.closeWithdrawMethod();
				this.openWithdrawRequest();
				break;
			default:
				break;
		}
	};

	isValidPhoneRegis = () => {
		this.refreshCheckFilled();
		if (this.state.phoneNumberRegis === "" || !this.state.phoneNumberRegis) {
			this.setState({
				isPhoneNUmberRegisValid: false,
				alertMsg: "Bạn chưa điền số điện thoại đăng ký",
			});
			return "Bạn chưa điền số điện thoại đăng ký";
		}
		return "";
	};

	onRegisPhoneNumberChange = (e) => {
		this.setState(
			{
				phoneNumberRegis: e.target.value,
			},
			() => this.isValidPhoneRegis()
		);
	};

	onRegisterVtpayBtn = () => {
		const phoneNumber = this.state.phoneNumberRegis;

		this.setState({ err: commonErr.LOADING });

		updateViettelpayInfo(false, phoneNumber).then((resp) => {
			this.setState({
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				showRegisterVtpay: false,
			});
			if (resp.data.error == commonErr.SUCCESS) {
				this.setState({
					errMsg: this.renderRegisVtpMessage(),
				});
			}
		});

		this.getWalletInfo(0);
	};

	onRequestWithdrawBtn = () => {
		const message = this.isValidInfo(this.state.withdrawMethod);
		if (message !== "") {
			this.setState({
				err: commonErr.FAIL,
				errMsg: message,
			});
		} else {
			this.setState({ err: commonErr.LOADING });

			if (this.state.withdrawMethod === withdrawMethods.BANK) {
				const data = {
					accountNumber: this.state.accountNumber,
					accountName: this.state.accountName,
					bankName: this.state.bankName,
				};

				updateBankInfo(data).then((resp) => {
					if (resp.data.err <= commonErr.SUCCESS) {
						this.setState({
							err: resp.data.error,
							errMsg: resp.data.errorMessage,
						});
					}
				});
			}

			const withdrawInfo = {
				amount: this.state.amount,
				method: this.state.withdrawMethod,
			};

			withdrawMoney(false, withdrawInfo).then((resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					showWithdrawRequest: false,
				});
				if (resp.data.error == commonErr.SUCCESS) {
					this.setState({
						errMsg: this.renderMessage(),
					});
				} else {
					this.setState({
						isSubmittedSuccess: false,
					});
				}
			});
			this.getWalletInfo(0);
		}
	};

	renderRegisVtpMessage = () => {
		return (
			<div className="message-box">
				Yêu cầu đang được xử lý!
				<p>
					Nhân viên Viettel Pay sẽ liên hệ bạn trong thời gian sớm nhất (ước tính từ 1-3 ngày làm việc) để thực hiện tư
					vấn và tiến hành mở tài khoản!
				</p>
			</div>
		);
	};

	renderMessage = () => {
		return (
			<div className="message-box">
				Gửi yêu cầu thành công
				<div className="message-box">
					<p>Yêu cầu rút tiền đã được gửi đi.</p>
					{this.state.withdrawMethod === withdrawMethods.BANK ? (
						<p>
							Bộ phận kế toán sẽ tiến hành xử lý yêu cầu rút tiền của bạn trong vòng 3 ngày làm việc tiếp theo (không kể
							Thứ 7 - Chủ nhật và ngày lễ Tết) kể từ khi yêu cầu được gửi
						</p>
					) : (
						<p>Tiền sẽ được chuyển vào tài khoản ViettelPay của bạn trong ngày làm việc kế tiếp.</p>
					)}
					<p>Để được hỗ trợ, vui lòng gọi hotline 19009217 (T2-T7, 9AM-9PM).</p>
					<p>Xin cám ơn,</p>
					<p>MIOTO TEAM</p>
				</div>
			</div>
		);
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	close = () => {
		this.setState({
			showConfirmCancelWithdraw: false,
		});
	};

	onWithdrawMethodChange = (method) => {
		this.setState({
			withdrawMethod: method,
		});
	};

	onSearchFieldChange = (e) => {
		this.setState({
			searchField: e.target.value,
		});
	};

	toggleShowListBank = () => {
		this.setState({
			showListBank: !this.state.showListBank,
		});
	};

	chooseBankName = (bank) => {
		this.setState({
			bankName: bank.id, //post to server
			bankSubName: bank.subName, // show to user on bank field
			bankFullName: bank.name, // show to user on bank field
		});
		this.toggleShowListBank();
	};

	getBankName = () => {
		const { banks, bankName } = this.state;
		const result = banks.filter((bank) => bank.id === bankName || bank.subName === bankName);
		if (result.length) {
			this.setState({
				bankName: result[0].id,
				bankSubName: result[0].subName,
				bankFullName: result[0].name,
			});
		} else {
			//defaul when first withdraw money or wrong bank name
			this.setState({
				bankName: "",
			});
		}
	};

	buildContentRequestForm = () => {
		const { banks, searchField, showListBank, bankName, bankSubName, bankFullName } = this.state;
		const filteredBanks = banks.filter(
			(bank) =>
				bank.name.toLowerCase().includes(searchField.toLowerCase()) ||
				bank.id.toLowerCase().includes(searchField.toLowerCase()) ||
				bank.subName.toLowerCase().includes(searchField.toLowerCase())
		);

		const withdrawMethod = this.state.withdrawMethod;
		switch (withdrawMethod) {
			case withdrawMethods.BANK:
				return (
					<React.Fragment>
						<div className="custom-dropdown">
							<p className="title font-14">Ngân hàng thụ hưởng (*)</p>
							<div className={`dropdown-selected ${showListBank ? "selected" : ""}`} onClick={this.toggleShowListBank}>
								{bankName ? (
									<p className="font-14">
										{bankSubName}
										<span>
											-<span className="font-12">{bankFullName}</span>
										</span>
									</p>
								) : (
									<p className="font-14">Chọn ngân hàng thụ hưởng</p>
								)}
							</div>
							{showListBank && (
								<div className="dropdown-option">
									<div className="dropdown-option__item search">
										<div className="wrap-svg">
											<IcSearchDropDown />
										</div>
										<input
											placeholder="Tìm kiếm ngân hàng"
											type="text"
											value={searchField}
											onChange={this.onSearchFieldChange}
										/>
									</div>
									<React.Fragment>
										{filteredBanks &&
											filteredBanks.map((bank) => (
												<div key={bank.id} onClick={() => this.chooseBankName(bank)} className="dropdown-option__item">
													<div className="bank-img">
														<img loading="lazy" src={bank.logo} />
													</div>
													<div className="bank-name">
														<p className="font-14">{bank.subName} </p>
														<p className="font-12">{bank.name}</p>
													</div>
												</div>
											))}
									</React.Fragment>
								</div>
							)}
						</div>
						<div className="space" />
						<p className="fontWeight-7 text-success font-14">NGƯỜI THỤ HƯỞNG (*)</p>
						<div className="line-form">
							<div className="custom-input">
								<div className="wrap-info">
									<div className="title-status">
										<p>Số tài khoản (*)</p>
									</div>
								</div>
								<div className={`wrap-input ${this.state.isAccountNumberValid ? "" : "error"}`}>
									<input
										disabled={!bankName}
										placeholder="Vui lòng nhập số tài khoản của bạn"
										type="text"
										name="accountNumber"
										value={this.state.accountNumber}
										onChange={this.handleInputChange}
									/>
								</div>
							</div>
						</div>
						<div className="line-form">
							<div className="custom-input">
								<div className="wrap-info">
									<div className="title-status">
										<p>Tên người thụ hưởng (*)</p>
									</div>
								</div>
								<div className={`wrap-input ${this.state.isAccountNameValid ? "" : "error"}`}>
									<input
										disabled={!bankName}
										placeholder="Vui lòng nhập tên người thụ hưởng"
										type="text"
										name="accountName"
										value={this.state.accountName}
										onChange={this.handleInputChange}
									/>
								</div>
							</div>
						</div>
						<p className="fontWeight-7 text-success font-14">PHÍ CHUYỂN TIỀN (11.000VND)</p>
					</React.Fragment>
				);
			case withdrawMethods.VIETTELPAY:
				return (
					<div className="line-form">
						<div className="custom-input">
							<div className="wrap-info">
								<div className="title-status">
									<p>Số điện thoại (*)</p>
								</div>
							</div>
							<div className="wrap-input disabled">
								<input type="text" disabled="" value={this.state.vtPayPhoneNumber} />
							</div>
						</div>
					</div>
				);
			default:
				return (
					<div className="block-bg">
						<p className="text-danger font-14 textAlign-center">Có lỗi xảy ra. Vui lòng tải lại trang</p>
					</div>
				);
		}
	};

	render() {
		var monthData = this.initMonthData();
		var content;
		var timeRequestContent = "";
		var btnWithdrawContent = (
			<a onClick={this.openWithdrawMethod} className="btn btn--m btn-primary">
				Gửi yêu cầu rút tiền
			</a>
		);
		if (this.state.err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else {
			if (this.state.timeRequested && this.state.timeRequested > 0) {
				btnWithdrawContent = (
					<a onClick={this.confirmCancelWithdrawRequest} className="btn btn--m btn-red">
						Hủy yêu cầu rút tiền
					</a>
				);
				timeRequestContent = (
					<p>Thời gian yêu cầu rút tiền: {moment(this.state.timeRequested).format("DD-MM-YYYY HH:mm")}</p>
				);
			}
			content = (
				<div className="module-register">
					<div className="m-container">
						<div className="main-title">
							<Link className="back d-flex" to={MY_CARS}>
								<div className="wrap-svg">
									<IcBackReport />
								</div>
								<p>Quay lại</p>
							</Link>
							<h4>Ví của tôi</h4>
						</div>
					</div>
					<div className="register-container owner-report">
						<div className="owner-report__wrap">
							<div className="owner-report--heading">
								<h4 className="title">Bảng tổng hợp giao dịch</h4>
								<div className="line-form">
									<div className="wrap-select custom-select--dark">
										<select
											value={
												this.state.monthInMilliseconds
													? this.state.monthInMilliseconds
													: monthData[0].monthInMilliseconds
											}
											onChange={this.onSelectMonthChange}>
											{monthData.map((monthObj) => (
												<option key={monthObj.monthInMilliseconds} value={monthObj.monthInMilliseconds}>
													Tháng {monthObj.monthInText.slice(3)}
												</option>
											))}
										</select>
									</div>
								</div>
							</div>
							<div className="owner-report--body textAlign-center">
								<div className="balance-summary">
									<h3>
										<NumberFormat
											value={this.state.balance}
											displayType={"text"}
											thousandSeparator={" "}
											decimalSeparator={","}
											suffix={"đ"}
										/>
									</h3>
									<p>Số dư hiện tại </p>
								</div>
								{this.state.data && (
									<WalletItem data={this.state.data} monthInMilliseconds={this.state.monthInMilliseconds}></WalletItem>
								)}
							</div>
							<div className="down-report">
								{/* <label>Tải sao kê chi tiết giao dịch</label>
							<div className="d-flex">
								<button className="btn btn--s btn-default">PDF</button>
								<button className="btn btn--s btn-default">Excel</button>
							</div> */}
								{timeRequestContent}
							</div>
						</div>
					</div>
					<div className="wrap-btn report-btn d-flex">
						{btnWithdrawContent}
						<Link
							className="btn btn--m btn-secondary"
							to={{
								pathname: `/mymonthlyreport/${moment(Number(this.state.monthInMilliseconds)).format("MM-YYYY")}`,
							}}>
							Xem Sao kê chi tiết giao dịch
						</Link>
					</div>
				</div>
			);
		}

		return (
			<div className="mioto-layout">
				<Header />
				<StickyContainer>
					<section className="body">
						{content}
						<Modal
							show={this.state.showWithdrawMethod}
							onHide={this.closeWithdrawMethod}
							dialogClassName="modal-s modal-dialog modal-input owner-balance">
							<Modal.Header closeButton={true} closeLabel={""}>
								<h5>Chọn phương thức rút tiền</h5>
							</Modal.Header>
							<Modal.Body>
								<div className="modal-input-body">
									<p className="font-14">Lựa chọn một trong hai hình thức rút tiền từ ví Mioto</p>
									<div className="choosing">
										<div className="custom-radio">
											<input
												id="widthdraw_method_1"
												type="radio"
												name="withdraw_method"
												onChange={() => this.onWithdrawMethodChange(withdrawMethods.BANK)}
												checked={this.state.withdrawMethod === withdrawMethods.BANK}
											/>
											<label htmlFor="widthdraw_method_1">
												<div className="content">
													<img loading="lazy" src="https://www.mioto.vn/static/media/cards.945d7e71.svg" alt="" />
													<p className="font-14 fontWeight-4">Chuyển khoản ngân&nbsp;hàng</p>
												</div>
											</label>
										</div>
										<div className="custom-radio">
											<input
												id="withdraw_method_2"
												type="radio"
												name="withdraw_method"
												onChange={() => this.onWithdrawMethodChange(withdrawMethods.VIETTELPAY)}
												checked={this.state.withdrawMethod === withdrawMethods.VIETTELPAY}
											/>
											<label htmlFor="withdraw_method_2">
												<div className="content">
													<img loading="lazy" src="https://www.mioto.vn/static/media/viettelpay.ad19e79b.svg" alt="" />
													<p className="font-14 fontWeight-4">ViettelPay</p>
												</div>
											</label>
										</div>
									</div>
									<div className="wrap-btn">
										<a className="btn btn--m btn-primary" onClick={this.onContinueWWithdrawMethod}>
											Tiếp tục
										</a>
									</div>
								</div>
							</Modal.Body>
						</Modal>

						<Modal
							show={this.state.showWithdrawRequest}
							onHide={this.closeWithdrawRequest}
							dialogClassName="modal-s modal-dialog modal-input owner-balance-3">
							<Modal.Header closeButton={true} closeLabel={""}>
								<h5>Yêu cầu rút tiền</h5>
							</Modal.Header>
							<Modal.Body>
								<div className="modal-input-body">
									<p className="font-14">
										Với trách nhiệm thuộc về Tôi/Chúng tôi, đề nghị Quý Công ty ghi nợ tài khoản của Tôi/Chúng tôi để
										thực hiện chuyển tiền theo nội dung sau:
									</p>
									{this.state.alertMsg !== "" && (
										<div className="block-bg">
											<p className="text-danger font-14">{this.state.alertMsg}</p>
										</div>
									)}
									<div className="line-form">
										<div className="custom-input">
											<div className="wrap-info">
												<div className="title-status">
													<p>Số tiền (*)</p>
												</div>
											</div>
											<div className="wrap-input disabled">
												<NumberFormat
													className="font-14 fontWeight-6"
													value={this.state.amount}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"đ"}
												/>
											</div>
										</div>
									</div>
									{this.buildContentRequestForm()}
									<div className="wrap-btn">
										<a className="btn btn--m btn-primary" onClick={this.onRequestWithdrawBtn}>
											Gửi yêu cầu
										</a>
									</div>
								</div>
							</Modal.Body>
						</Modal>
						<MessageBox
							show={this.state.err <= commonErr.SUCCESS}
							hideModal={this.hideMessageBox}
							message={this.state.errMsg}
							error={this.state.err}
						/>

						<Modal
							show={this.state.showRegisterVtpay}
							onHide={this.closeRegisterVtpay}
							dialogClassName="modal-sm modal-confirm modal-regis-viettelpay">
							<Modal.Header closeButton={true} closeLabel={""}>
								<h5>Rút tiền nhanh từ ví Mioto với thẻ Viettel Pay!</h5>
							</Modal.Header>
							<Modal.Body>
								<div className="register-container">
									<div className="register-wrapper">
										<div className="form-default">
											{this.state.alertMsg !== "" && (
												<div className="message-valid-box">
													<p
														style={{
															color: "#c40012",
															marginBottom: "0px",
														}}>
														{this.state.alertMsg}
													</p>
												</div>
											)}
											<div className="line-form">
												<label>Số điện thoại đăng ký</label>
												<div
													className={this.state.isPhoneNUmberRegisValid ? "wrap-input" : "wrap-input has-error-form"}>
													{this.state.vtpayTimeRequested === 0 && this.state.vtpayTimeActived === 0 ? (
														<input
															type="text"
															value={this.state.phoneNumberRegis}
															onChange={this.onRegisPhoneNumberChange}
														/>
													) : (
														<input disabled type="text" value={this.state.phoneNumberRegis} />
													)}
												</div>
											</div>
										</div>
										<p>
											Mioto phối hợp cùng Viettel Pay triển khai tính năng rút tiền nhanh dành cho các đối tác chủ xe
											Mioto thông qua tài khoản ngân hàng số Viettel Pay, rút ngắn thời gian xử lí trong vòng 1 ngày và
											tiết kiệm phí giao dịch.
										</p>
										<div className="benefit-withdraw">
											<h4>Tiện ích từ Mioto</h4>
											<table className="benefit-table">
												<thead>
													<tr>
														<th />
														<th>Viettel Pay</th>
														<th>Chuyển khoản Ngân hàng</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<th>Thời gian xử lí</th>
														<td>1 ngày làm việc</td>
														<td>3 ngày làm việc</td>
													</tr>
													<tr>
														<th>Phí giao dịch</th>
														<td>3,000 VNĐ / giao dịch</td>
														<td>11,000 VNĐ / giao dịch</td>
													</tr>
												</tbody>
											</table>
										</div>
										<div className="benefit-withdraw">
											<h4>Ưu đãi khác từ Viettel Pay</h4>
											<div className="benefit-item__wrap">
												<div className="benefit-item">
													<i className="ict-benefit ict-bank" />
													<p>Miễn phí chuyển khoản đến 43 ngân hàng</p>
												</div>
												<div className="benefit-item">
													<i className="ict-benefit ict-withdraw" />
													<p>Miễn phí rút tiền tại tất cả ATM và 200.000 cửa hàng Viettel trên toàn quốc</p>
												</div>
												<div className="benefit-item">
													<i className="ict-benefit ict-account" />
													<p>Không phí duy trì tài khoản</p>
												</div>
												<div className="benefit-item">
													<i className="ict-benefit ict-phone-card" />
													<p>Chiết khấu 5% mua thẻ cào, nạp cước điện thoại</p>
												</div>
												<div className="benefit-item">
													<i className="ict-benefit ict-payment" />
													<p>Hơn 100+ tiện ích thanh toán và mua sắm trên Viettel Pay</p>
												</div>
											</div>
										</div>
										<div className="benefit-footer">
											<p>Tư vấn, cài đặt và mở tài khoản miễn phí - tận nhà bởi nhân viên Viettel.</p>
											<p>
												Các chủ xe trên ứng dụng có thể đăng kí mở tài khoản ngân hàng số Viettel Pay ngay tại đây !
											</p>
										</div>

										<div className="wrap-btn d-flex">
											{/* <a className="btn btn--m btn-default" onClick={this.closeRegisterVtpay}>Bỏ qua</a> */}
											{this.state.vtpayTimeRequested === 0 && this.state.vtpayTimeActived === 0 ? (
												<a
													className={
														this.state.isPhoneNUmberRegisValid
															? "btn btn--m btn-primary"
															: "btn btn--m btn-primary disabled"
													}
													onClick={this.onRegisterVtpayBtn}>
													Đăng ký ngay
												</a>
											) : (
												<a className="btn btn--m btn-secondary" onClick={this.cancelRegisterVtpay}>
													Hủy yêu cầu đang xử lý
												</a>
											)}
										</div>
									</div>
								</div>
							</Modal.Body>
						</Modal>

						<Modal
							show={this.state.showConfirmCancelWithdraw}
							onHide={this.close}
							dialogClassName="modal-s modal-dialog modal-confirm">
							<Modal.Header closeButton={true} closeLabel={""}>
								<h5>Thông báo</h5>
							</Modal.Header>
							<Modal.Body>
								<div className="modal-confirm-body">
									<p className="font-14">Bạn muốn hủy yêu cầu rút tiền?</p>
									<div className="wrap-btn has-2-btn">
										<a className="btn btn--m btn-primary" onClick={this.cancelWithdrawRequest}>
											Đồng ý
										</a>
										<a className="btn btn-link" onClick={this.close}>
											Bỏ qua
										</a>
									</div>
								</div>
							</Modal.Body>
						</Modal>
							<Login
								show={this.state.showLoginForm}
								showModal={this.openLoginForm}
								hideModal={this.closeLoginForm}
								openSignupForm={this.openSignupForm}
								getLoggedProfile={this.getLoggedProfile}
							/>
							<SignUp
								show={this.state.showSignup}
								showModal={this.openSignupForm}
								hideModal={this.closeSignupForm}
								openLoginForm={this.openLoginForm}
								getLoggedProfile={this.getLoggedProfile}
							/>
					</section>
				</StickyContainer>
			</div>
		);
	}
}

export default MyWallet;
